export default __webpack_public_path__ + "static/media/buster_klein_67.040f5551.jpg";